/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialClassStudentViewModelPaginatedResponse } from "../types/CourseFinancialClassStudentViewModelPaginatedResponse.ts";
import { courseFinancialClassStudentViewModelSchema } from "./courseFinancialClassStudentViewModelSchema.ts";

export const courseFinancialClassStudentViewModelPaginatedResponseSchema =
  z.object({
    data: z
      .array(z.lazy(() => courseFinancialClassStudentViewModelSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<CourseFinancialClassStudentViewModelPaginatedResponse>;
